module.exports = __webpack_public_path__ + "img/logo.e2920d9b.svg";